<!-- Horizontal tabs -->
@if (!vertical) {
  <!-- Tab navigation -->
  <ul [class]="navClass" role="tablist">
    @for (tab of tabPanels; track tab) {
      <li class="nav-item" role="presentation">
        <button
          type="button"
          class="nav-link"
          [class.active]="isActive(tab.id)"
          [class.disabled]="tab.disabled"
          [attr.aria-selected]="isActive(tab.id)"
          [attr.aria-controls]="'panel-' + tab.id"
          [attr.id]="'tab-' + tab.id"
          [disabled]="tab.disabled"
          (click)="selectTab(tab.id)"
          role="tab">
          @if (tab.icon) {
            <lucide-icon [name]="tab.icon" class="icon-sm me-1"></lucide-icon>
          }
          <span>{{ tab.title }}</span>
          @if (tab.badge) {
            <hc-badge [color]="tab.badgeColor" size="small" variant="heavy" class="ms-1">{{ tab.badge }}</hc-badge>
          }
        </button>
      </li>
    }
  </ul>
  <!-- Tab content -->
  <div class="tab-content p-3">
    @for (tab of tabPanels; track tab) {
      <div
        class="tab-pane"
        [class.active]="isActive(tab.id)"
        [class.show]="isActive(tab.id)"
        [attr.id]="'panel-' + tab.id"
        [attr.aria-labelledby]="'tab-' + tab.id"
        role="tabpanel">
        @if (isActive(tab.id)) {
          <ng-container *ngTemplateOutlet="tab.contentTemplate"></ng-container>
        }
      </div>
    }
  </div>
}

<!-- Vertical tabs -->
@if (vertical) {
  <div class="row">
    <!-- Left navigation -->
    @if (verticalPosition === 'left') {
      <div class="col-md-3">
        <ul [class]="navClass" role="tablist">
          @for (tab of tabPanels; track tab) {
            <li class="nav-item" role="presentation">
              <button
                type="button"
                class="nav-link mb-2"
                [class.active]="isActive(tab.id)"
                [class.disabled]="tab.disabled"
                [attr.aria-selected]="isActive(tab.id)"
                [attr.aria-controls]="'panel-' + tab.id"
                [attr.id]="'tab-' + tab.id"
                [disabled]="tab.disabled"
                (click)="selectTab(tab.id)"
                role="tab">
                @if (tab.icon) {
                  <lucide-icon [name]="tab.icon" class="icon-sm me-1"></lucide-icon>
                }
                <span>{{ tab.title }}</span>
                @if (tab.badge) {
                  <hc-badge [color]="tab.badgeColor" size="small" variant="heavy" class="ms-1">{{ tab.badge }}</hc-badge>
                }
              </button>
            </li>
          }
        </ul>
      </div>
    }
    <!-- Content -->
    <div [class]="verticalPosition === 'left' ? 'col-md-9' : 'col-md-9 order-first'">
      <div class="tab-content">
        @for (tab of tabPanels; track tab) {
          <div
            class="tab-pane"
            [class.active]="isActive(tab.id)"
            [class.show]="isActive(tab.id)"
            [attr.id]="'panel-' + tab.id"
            [attr.aria-labelledby]="'tab-' + tab.id"
            role="tabpanel">
            @if (isActive(tab.id)) {
              <ng-container *ngTemplateOutlet="tab.contentTemplate"></ng-container>
            }
          </div>
        }
      </div>
    </div>
    <!-- Right navigation -->
    @if (verticalPosition === 'right') {
      <div class="col-md-3">
        <ul [class]="navClass" role="tablist">
          @for (tab of tabPanels; track tab) {
            <li class="nav-item" role="presentation">
              <button
                type="button"
                class="nav-link mb-2"
                [class.active]="isActive(tab.id)"
                [class.disabled]="tab.disabled"
                [attr.aria-selected]="isActive(tab.id)"
                [attr.aria-controls]="'panel-' + tab.id"
                [attr.id]="'tab-' + tab.id"
                [disabled]="tab.disabled"
                (click)="selectTab(tab.id)"
                role="tab">
                @if (tab.icon) {
                  <lucide-icon [name]="tab.icon" class="icon-sm me-1"></lucide-icon>
                }
                <span>{{ tab.title }}</span>
                @if (tab.badge) {
                  <hc-badge [color]="tab.badgeColor" size="small" variant="heavy" class="ms-1">{{ tab.badge }}</hc-badge>
                }
              </button>
            </li>
          }
        </ul>
      </div>
    }
  </div>
}
